@use '@lib/assets/styles/main.scss' as *;

.subTitle {
  margin-bottom: 8px;
}

.supportiveMessage {
  margin-top: 24px;
}
